const {flattenObject} = require('./Utils');

const ProjectAction = {
    PROJECT: {                  //Prefix: 0
        EDIT: '0-0',
        ARCHIVE: '0-1',
        CHANGE_OWNER: '0-2'
    },

    MEMBER: {                   //Prefix: 1
        VIEW: '1-0',
        APPROVE: '1-1',
        CHANGE_ROLE: '1-2',
        REMOVE: '1-3'
    },

    ROLE: {                     //Prefix: 2
        VIEW: '2-0',
        CREATE: '2-1',
        EDIT: '2-2',
        DELETE: '2-3',
    },

    ANNOUNCEMENT: {             //Prefix: 3
        VIEW: '3-0',
        CREATE: '3-1',
        EDIT: '3-2',
        DELETE: '3-3',
        UNCLEAR_ALL: '3-4'
    },

    FILE: {                     //Prefix: 4
        VIEW: '4-0',
        CREATE: '4-1',
        DOWNLOAD: '4-2',
        EDIT: '4-3',
        DELETE: '4-4',
    },

    MODEL: {                    //Prefix: 5
        VIEW: '5-0',
        CREATE: '5-1',
        DOWNLOAD: '5-2',
        EDIT: '5-3',
        DELETE: '5-4',
    },

    VIEWPOINT: {                //Prefix: 6
        VIEW: '6-0',
        CREATE: '6-1',
        DOWNLOAD: '6-2',
        EDIT: '6-3',
        DELETE: '6-4',
    },

    VIEWPOINT_GROUP: {           //Prefix: 7
        VIEW: '7-0',
        CREATE: '7-1',
        DOWNLOAD: '7-2',
        EDIT: '7-3',
        DELETE: '7-4',
    },

    VOLUME_GROUP: {             //Prefix: 8
        VIEW: '8-0',
        CREATE: '8-1',
        DOWNLOAD: '8-2',
        EDIT: '8-3',
        DELETE: '8-4',
    },

    SCENE_STATE: {              //Prefix: 9
        VIEW: '9-0',
        CREATE: '9-1',
        DOWNLOAD: '9-2',
        EDIT: '9-3',
        DELETE: '9-4',
    },

    SESSION: {                  //Prefix: 10
        VIEW: '10-0',
        CREATE: '10-1',
        DOWNLOAD: '10-2',
        EDIT: '10-3',
        DELETE: '10-4',
    },

    TAG: {                      //Prefix: 11
        VIEW: '11-0',
        CREATE: '11-1',
        DOWNLOAD: '11-2',
        EDIT: '11-3',
        DELETE: '11-4',
    },

    PANORAMIC_IMAGE: {          //Prefix: 12
        VIEW: '12-0',
        CREATE: '12-1',
        DOWNLOAD: '12-2',
        EDIT: '12-3',
        DELETE: '12-4',
    },

    PANORAMIC_VIDEO: {          //Prefix: 13
        VIEW: '13-0',
        CREATE: '13-1',
        DOWNLOAD: '13-2',
        EDIT: '13-3',
        DELETE: '13-4',
    },

    IMAGE: {                    //Prefix: 14
        VIEW: '14-0',
        CREATE: '14-1',
        DOWNLOAD: '14-2',
        EDIT: '14-3',
        DELETE: '14-4',
    },

    AUDIO: {                    //Prefix: 15
        VIEW: '15-0',
        CREATE: '15-1',
        DOWNLOAD: '15-2',
        EDIT: '15-3',
        DELETE: '15-4',
    },

    VIDEO: {                    //Prefix: 17
        VIEW: '17-0',
        CREATE: '17-1',
        DOWNLOAD: '17-2',
        EDIT: '17-3',
        DELETE: '17-4',
    },

    DOCUMENT: {                 //Prefix: 18
        VIEW: '18-0',
        CREATE: '18-1',
        DOWNLOAD: '18-2',
        EDIT: '18-3',
        DELETE: '18-4',
    },

    ENVIRONMENT: {              //Prefix: 19
        VIEW: '19-0',
        CREATE: '19-1',
        DOWNLOAD: '19-2',
        EDIT: '19-3',
        DELETE: '19-4',
    },

    AVATAR: {                   //Prefix: 20
        VIEW: '20-0',
        CREATE: '20-1',
        DOWNLOAD: '20-2',
        EDIT: '20-3',
        DELETE: '20-4',
    },

    CABLE: {                    //Prefix: 21
        VIEW: '21-0',
        CREATE: '21-1',
        DOWNLOAD: '21-2',
        EDIT: '21-3',
        DELETE: '21-4',
    },

    TRAINING: {                 // Prefix: 22
        VIEW: '22-0',
        CREATE: '22-1',
        DOWNLOAD: '22-2',
        EDIT: '22-3',
        DELETE: '22-4',
    },

    MEETING: {                  //Prefix: 23
        VIEW: '23-0',
        CREATE: '23-1',
        CREATE_PUBLIC: '23-2',
        EDIT: '23-3',
        DELETE: '23-4',
        JOIN: '23-5',
        VIEW_LOG: '23-6'
    },

    MEETING_SETTINGS: {         //Prefix: 24
        VIEW: '24-0',
        EDIT: '24-1',
        OVERRIDE: '24-2'
    },

    MENU: {                     // Prefix: 25
        VIEW: '25-0',
        CREATE: '25-1',
        EDIT: '25-2',
        EDIT_DEFAULT: '25-3',
        DELETE: '25-4'
    },

    MEETING_TEMPLATE: {         // Prefix: 26
        VIEW: '26-0',
        CREATE: '26-1',
        EDIT: '26-2',
        DELETE: '26-3',
    },

    GENERATE_MODEL: {           // Prefix: 27
        VIEW: '27-0',
        RUN: '27-1',
        VIEW_LOG: '27-2',
        CANCEL: '27-3'
    },

    GENERATION_SETTINGS: {      // Prefix: 28
        VIEW: '28-0',
        CREATE: '28-1',
        EDIT: '28-2',
        EDIT_DEFAULT: '28-3',
        DELETE: '28-4'
    },

    MODELLER: {                  //Prefix: 29
        VIEW: '29-0',
        CREATE: '29-1',
        DOWNLOAD: '29-2',
        EDIT: '29-3',
        DELETE: '29-4',
    }
};

const ProjectActionFlat = flattenObject(ProjectAction);

module.exports = {
    ProjectAction,
    ProjectActionFlat
};
